import imageCompression from 'browser-image-compression'

/**
 * 压缩图片
 * @param file 原始图片文件
 * @param maxSizeMB 最大文件大小 (MB)
 * @param maxWidthOrHeight 最大宽度或高度 (px)
 * @returns 压缩后的图片文件
 */
export async function compressImage(
  file: File,
  maxSizeMB = 1,
  maxWidthOrHeight = 1440
): Promise<File> {
  const options = {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
  }

  try {
    const compressedFile = await imageCompression(file, options)
    console.log(
      `✅ 图片压缩完成: ${file.name}`,
      `原始大小: ${(file.size / 1024 / 1024).toFixed(2)}MB`,
      `压缩后: ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`
    )
    return compressedFile
  } catch (error) {
    console.error('❌ 图片压缩失败:', error)
    throw error
  }
}

/**
 * 压缩 Base64 图片
 * @param base64 原始 Base64 字符串
 * @param maxSizeMB 最大文件大小 (MB)
 * @returns 压缩后的 Base64 字符串
 */
export async function compressBase64(
  base64: string,
  maxSizeMB = 1
): Promise<string> {
  if (!base64 || !base64.startsWith('data:')) return base64

  try {
    // 提取 MIME 类型
    const mime = base64.match(/:(.*?);/)?.[1] || 'image/png'
    
    // 转换为 Blob
    const res = await fetch(base64)
    const blob = await res.blob()
    const file = new File([blob], 'image.png', { type: mime })

    // 压缩
    const compressedFile = await compressImage(file, maxSizeMB)

    // 转回 Base64
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsDataURL(compressedFile)
    })
  } catch (error) {
    console.error('❌ Base64 压缩失败:', error)
    return base64 // 失败时返回原图，不中断流程
  }
}

/**
 * 批量压缩图片
 * @param files 图片文件数组
 * @returns 压缩后的图片文件数组
 */
export async function compressImages(files: File[]): Promise<File[]> {
  return Promise.all(files.map((file) => compressImage(file)))
}

